import React from 'react'
import useSWR from 'swr'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'

const InReviewTemplates = () => {
  const { data = [], isLoading, isValidating, mutate } = useSWR(['/drafts'])

  const table = useReactTable({
    data,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  if (isLoading || isValidating) return <Loader />
  if (!data) return <EmptyDatas />
  return (
    <div className="flex h-[calc(100vh-150px)] flex-col">
      <div className="mb-2 flex-shrink-0">
        <DataTableToolbar mutate={mutate} />
      </div>
      <div className="min-h-0 flex-1">
        <Card className="flex h-full flex-col">
          <CardContent className="flex-1 overflow-hidden pb-0 pl-4 pr-0">
            <div className="h-full overflow-auto">
              <Table table={table} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default InReviewTemplates
